import { render } from "./FeaturedContent.vue?vue&type=template&id=59c7a8b2&scoped=true"
import script from "./FeaturedContent.vue?vue&type=script&lang=js"
export * from "./FeaturedContent.vue?vue&type=script&lang=js"

import "./FeaturedContent.vue?vue&type=style&index=0&id=59c7a8b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c7a8b2"]])

export default __exports__